/**
 * Effective purchase price for a product, given the current user.
 *
 * Products may carry an optional wholesale `seller_price` alongside retail
 * `price`. Seller accounts buying stock for resale pay wholesale; everyone
 * else pays retail.
 *
 * This mirrors `EffectivePurchasePrice` in the backend
 * (handlers/pricing.go) exactly — including the guards that treat a
 * non-positive or above-retail wholesale price as unset. The backend is
 * authoritative for what is actually charged; this exists so the price shown
 * in the UI can never disagree with it.
 */
export const getEffectivePrice = (product, user) => {
  if (!product) return 0;

  const retail = Number(product.price ?? product.retail_price ?? 0);
  const wholesale = Number(product.seller_price ?? product.sellerPrice ?? 0);

  if (!isSellerUser(user)) return retail;
  if (!wholesale || wholesale <= 0 || wholesale > retail) return retail;

  return wholesale;
};

/** Whether a user account gets wholesale pricing. */
export const isSellerUser = (user) =>
  user?.user_type === 'seller' || user?.userType === 'seller';
